import React from "react";
import styles from "../add-funds.module.scss";
import Button from "components/primary-button/button";
import classNames from "classnames";
import { motion } from "framer-motion";
import { successIcon } from "base/SVG";
import { useNavigate } from "react-router-dom";
export default function Step4({ setModal, amount }) {
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      exit={{ opacity: 0, y: 20 }}
      className={styles["block"]}
    >
      <div className={styles["block__icon"]}>{successIcon}</div>
      <div className={styles["block__head"]}>
        <h4>Deposit Confirmed</h4>
        <p className="sm">
          Your deposit of <strong>{amount} USD</strong> is confirmed and available in
          your NextBlock wallet.
        </p>
      </div>

      <div className={classNames(styles["block__btns"], styles["center"])}>
        <Button
          type={"primary"}
          text={"Go to Dashboard"}
          onClick={() => {
            setModal(false);
            //navigate("./app/billing");
            window.location.href = "../../../app/dashboard";
          }}
        />
      </div>
    </motion.div>
  );
}
